// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__ic80d"};